import { getCommonIconProps, IconProps } from ".";

export const YoutubeIcon = (props: IconProps) => {
  return (
    <svg {...getCommonIconProps(props)}>
      <path
        d="m12.04 18.2c-.21 0-5.1 0-6.38-.35-.4-.11-.77-.32-1.06-.61s-.5-.66-.61-1.06c-.56-2.22-.4-5.65-.02-7.9.12-.43.33-.8.62-1.09s.66-.51 1.06-.61c1.28-.35 6.17-.36 6.38-.36s5.1 0 6.38.35c.4.11.77.32 1.06.61s.51.66.61 1.06c.55 2.21.42 5.65.02 7.91-.12.43-.33.8-.62 1.09s-.66.51-1.06.61c-1.28.34-6.17.35-6.38.35zm-.01-11.3c-.05 0-5.01.01-6.2.34-.28.08-.54.23-.75.43-.21.21-.36.47-.43.75-.38 2.21-.5 5.55.01 7.57.08.28.23.54.43.74.21.21.47.36.75.43 1.19.33 6.15.33 6.2.33s5.01 0 6.2-.33c.28-.08.54-.23.75-.43.21-.21.36-.46.43-.75.39-2.16.51-5.48-.01-7.58-.07-.28-.22-.53-.43-.74-.21-.21-.46-.36-.75-.43-1.2-.33-6.15-.33-6.2-.33zm-1.6 8.07c-.06 0-.12-.02-.17-.05-.11-.06-.18-.18-.18-.3v-4.84c0-.12.07-.24.18-.3s.24-.06.35 0l4.18 2.42c.11.06.17.18.17.3s-.07.24-.17.3l-4.18 2.42c-.06.03-.12.05-.18.05zm.35-4.59v3.63l3.13-1.81z"
        fill="currentColor"
      />
    </svg>
  );
};
